import getCompositeItemPosition from '../../../common/helpers/get-composite-item-position';
import toPositionPercents from './to-position-percents';

const MAX_POSITION_OFFSET = 75;

function calculateNewItemPosition(compositionGroupNode, breakpoint = null) {
  const initialPosition = [50, 50];
  let position = [...initialPosition];
  const step = 2.5;
  let shift = 0;

  let compositionItem = compositionGroupNode.firstElementChild;

  while (compositionItem) {
    const { x, y } = getCompositeItemPosition({ element: compositionItem, breakpoint });

    if (x === position[0] && y === position[1]) {
      position[0] += step;
      position[1] += step;

      if (position[0] > MAX_POSITION_OFFSET + shift || position[1] > MAX_POSITION_OFFSET) {
        shift += step;
        position = [...initialPosition];
        break;
      }
    }

    compositionItem = compositionItem.nextElementSibling;
  }

  return toPositionPercents(position);
}

export default calculateNewItemPosition;
